import * as moment from "moment";
import { LeaseDurationType } from "../../../types";

/**
 * How much of the lease is left to run, in years.
 *
 * A lease that has already started is measured from today to its end date;
 * anything else falls back to the term itself, since nothing has run off yet.
 * Returns null when the inputs can't produce a value — the caller keeps whatever
 * it already had (the lease dialog binds this to a disabled field).
 */
export function calculateUnexpiredLeaseTerms(
  startDate: Date | moment.Moment | null,
  duration: number | null,
  durationType: LeaseDurationType | null
): number | null {
  if (startDate) {
    const today = moment()
    const start = moment.isMoment(startDate) ? startDate : moment(startDate)
    if (start.isBefore(today)) {
      const endDate = start.clone().add(durationType === 'months' ? duration : duration * 12, 'M')
      const yearDiff = Math.abs(today.diff(endDate, 'years'))
      const monthDiff = calculateMonthDiff(today, endDate)
      const _value = yearDiff + (monthDiff / 12)
      const value = Math.round((_value + Number.EPSILON) * 100) / 100
      return isNaN(value) ? null : value
    }
  }

  if (duration && durationType) {
    return durationType === 'months' ? duration * 12 : duration
  }

  return null
}

function calculateMonthDiff(startDate: moment.Moment, endDate: moment.Moment) {
  // Calculate the difference in years and months
  let yearsDiff = endDate.year() - startDate.year();
  let monthsDiff = endDate.month() - startDate.month();

  // Calculate the number of months, ignoring the years
  let totalMonths = yearsDiff * 12 + monthsDiff;

  // Ensure the month difference accounts for partial month
  if (endDate.date() < startDate.date()) {
    totalMonths--;
  }

  let finalMonthsDiff = totalMonths % 12;

  return finalMonthsDiff
}
